import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const ContactFilters = ({ 
  searchTerm, 
  onSearchChange, 
  filters, 
  onFilterChange, 
  onClearFilters,
  totalContacts,
  filteredCount 
}) => {
  const companyOptions = [
    { value: '', label: 'Tüm Şirketler' },
    { value: 'Teknoloji A.Ş.', label: 'Teknoloji A.Ş.' },
    { value: 'İnşaat Ltd.', label: 'İnşaat Ltd.' },
    { value: 'Danışmanlık Hizmetleri', label: 'Danışmanlık Hizmetleri' },
    { value: 'Perakende Zinciri', label: 'Perakende Zinciri' },
    { value: 'Finans Grubu', label: 'Finans Grubu' }
  ];

  const locationOptions = [
    { value: '', label: 'Tüm Konumlar' },
    { value: 'İstanbul', label: 'İstanbul' },
    { value: 'Ankara', label: 'Ankara' },
    { value: 'İzmir', label: 'İzmir' },
    { value: 'Bursa', label: 'Bursa' },
    { value: 'Antalya', label: 'Antalya' }
  ];

  const statusOptions = [
    { value: '', label: 'Tüm Durumlar' },
    { value: 'Aktif', label: 'Aktif' },
    { value: 'Beklemede', label: 'Beklemede' },
    { value: 'Pasif', label: 'Pasif' }
  ];

  const priorityOptions = [
    { value: '', label: 'Tüm Öncelikler' },
    { value: 'Yüksek', label: 'Yüksek' },
    { value: 'Orta', label: 'Orta' },
    { value: 'Düşük', label: 'Düşük' }
  ];

  const campaignOptions = [
    { value: '', label: 'Tüm Kampanyalar' },
    { value: 'Yeni Ürün Tanıtımı', label: 'Yeni Ürün Tanıtımı' },
    { value: 'Müşteri Memnuniyeti', label: 'Müşteri Memnuniyeti' },
    { value: 'Satış Takibi', label: 'Satış Takibi' },
    { value: 'Geri Kazanım', label: 'Geri Kazanım' }
  ];

  const hasActiveFilters = filters?.company || filters?.location || filters?.status || filters?.priority || filters?.campaign;

  return (
    <div className="bg-white border-b border-slate-200 p-6">
      {/* Search Bar */}
      <div className="mb-4">
        <div className="relative">
          <Input
            type="search"
            placeholder="Ad, telefon veya şirket ile ara..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
          <Icon 
            name="Search" 
            size={18} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" 
          />
        </div>
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
        <Select
          placeholder="Şirket seç"
          options={companyOptions}
          value={filters?.company}
          onChange={(value) => onFilterChange('company', value)}
        />

        <Select
          placeholder="Konum seç"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
        />

        <Select
          placeholder="Durum seç"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Öncelik seç"
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange('priority', value)}
        />

        <Select
          placeholder="Kampanya seç"
          options={campaignOptions}
          value={filters?.campaign}
          onChange={(value) => onFilterChange('campaign', value)}
        />
      </div>
      {/* Filter Actions and Results */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
            >
              Filtreleri Temizle
            </Button>
          )}
          
          <div className="text-sm text-slate-600">
            {filteredCount !== totalContacts ? (
              <>
                <span className="font-medium">{filteredCount}</span> / {totalContacts} kişi gösteriliyor
              </>
            ) : (
              <>
                Toplam <span className="font-medium">{totalContacts}</span> kişi
              </>
            )}
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
          >
            Dışa Aktar
          </Button>
          
          <Button
            variant="default"
            size="sm"
            iconName="Plus"
          >
            Yeni Kişi
          </Button>
        </div>
      </div>
      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="mt-4 flex flex-wrap gap-2">
          {filters?.company && (
            <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
              Şirket: {filters?.company}
              <button
                onClick={() => onFilterChange('company', '')}
                className="ml-2 hover:text-primary/70"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.location && (
            <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
              Konum: {filters?.location}
              <button
                onClick={() => onFilterChange('location', '')}
                className="ml-2 hover:text-primary/70"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.status && (
            <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
              Durum: {filters?.status}
              <button
                onClick={() => onFilterChange('status', '')}
                className="ml-2 hover:text-primary/70"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.priority && (
            <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
              Öncelik: {filters?.priority}
              <button
                onClick={() => onFilterChange('priority', '')}
                className="ml-2 hover:text-primary/70"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.campaign && (
            <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
              Kampanya: {filters?.campaign}
              <button
                onClick={() => onFilterChange('campaign', '')}
                className="ml-2 hover:text-primary/70"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactFilters;